export default class subscriberFlowWidget {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/dashboard/widgets/subscriber-flow.html'),
            replace: true,
            controller: FlowCtrl,
            controllerAs: 'flow'
        }
    }
};

class FlowCtrl {
    constructor($filter, Statistics, ChartData) {
        this._filter = $filter;

        this.statisticsRepo = Statistics;
        this.chartDataService = ChartData;

        this.statsLoaded = false;
        this.showFlow = true;
        this.colorMap = this.chartDataService.getColorMap();

        this.settings = {
            new: true,
            suppressed: true,
            netGrowth: true,
            dates: {
                startDate: null,
                endDate: null
            }
        };

        this.chartOptions = {
            pointDot: false,
            scaleBeginAtZero: false,
            scaleFontColor: '#73879C',
            scaleFontSize: 10,
            scaleFontWeight: 300
        };

        this.getSubscriberFlow();
    }

    getSubscriberFlow() {
        this.statisticsRepo.subscriberFlow(this.settings).then((response) => {
            this.newSubscribers = response['statistics']['new'];
            this.suppressedSubscribers = response['statistics']['suppressed'];

            this.settings['dates'] = {
                startDate: this._filter('date')(response['startDate'], 'yyyy-MM-dd HH:mm:ss'),
                endDate: this._filter('date')(response['endDate'], 'yyyy-MM-dd HH:mm:ss')
            };

            this.generateNewSubscribersChart();
        });
    };

    generateNewSubscribersChart() {
        this.chartDataService.clear();

        let newSubscribersLabel = this._filter('translate')('DASHBOARD:NEW_SUBSCRIBERS');
        let suppressedSubscribersLabel = this._filter('translate')('DASHBOARD:SUPPRESSED_SUBSCRIBERS');

        this.chartData = this.chartDataService.addStatisticsData(
            newSubscribersLabel,
            this.newSubscribers,
            this.settings['dates'],
            this.colorMap['main'],
            this.settings['new'] == false
        );

        this.chartData = this.chartDataService.addStatisticsData(
            suppressedSubscribersLabel,
            this.suppressedSubscribers,
            this.settings['dates'],
            this.colorMap[0],
            this.settings['suppressed'] == false
        );

        this.chartData = this.chartDataService.netGrowthPerDate(
            newSubscribersLabel,
            suppressedSubscribersLabel,
            this.settings['netGrowth'] == false
        );

        this.statsLoaded = true;
    };

    hasStatistics() {
        return (this.newSubscribers && this.newSubscribers.length > 0) ||
            (this.suppressedSubscribers && this.suppressedSubscribers.length > 0);
    };

    setInterval(startDate, endDate) {
        if (startDate != this.settings.dates.startDate || endDate != this.settings.dates.endDate) {
            this.settings.dates.startDate = startDate;
            this.settings.dates.endDate = endDate;
            this.getSubscriberFlow();
        }
    };

    toggleActive(subscriberType) {
        this.settings[subscriberType] = ! this.settings[subscriberType];
        if (this.settings.new || this.settings.suppressed || this.settings.netGrowth) {
            this.generateNewSubscribersChart();
            this.showFlow = true;
        } else {
            this.showFlow = false;
        }
    };

    toggleShow() {
        this.showFlow = ! this.showFlow;
    };
}



